export default __webpack_public_path__ + "static/399-b77b8797412d9b9e0adb82c8e321926d.gif";